import {
  AppBar,
  Box,
  Toolbar,
  Typography,
  Button,
  Stack,
  Select,
  MenuItem,
} from "@mui/material";

import { useState, useEffect } from "react";

import { ReactComponent as IconChange } from "../images/iconChange.svg";
import { ReactComponent as IconUser } from "../images/iconPerfil.svg";
import { ReactComponent as IconLocation } from "../images/iconLocation.svg";
import { ReactComponent as IconStar } from "../images/iconStar.svg";
import { ReactComponent as IconStarFill } from "../images/iconStarFill.svg";

import ModalDialogs from "./ModalDialogs";

import api from "../services/api";
import { getItemDecrypt, setItemEncryp } from "../utils/cryptoData";

export default function HeaderPerfil({ onAtualizacao }) {
  const [openVinculo, setOpenVinculo] = useState(false);
  const [vinculo, setVinculo] = useState("Selecione");
  const [vinculosList, setVinculosList] = useState([]);
  const [vinculos, setVinculos] = useState([]);
  const [perfil, setPerfil] = useState("");
  const [perfilList, setPerfilList] = useState([]);
  const [vinculoEscolhido, setVinculoEscolhido] = useState({});
  const [idVinculoSelecionado, setIdVinculoSelecionado] = useState("");

  const handleAtualizacao = () => {
    onAtualizacao();
  };

  useEffect(() => {
    // const usuario = JSON.parse(localStorage.getItem("usuario"));
    // const vinculoAtivo = JSON.parse(localStorage.getItem("vinculo_ativo"));

    const usuario = getItemDecrypt("usuario");
    const vinculoAtivo = getItemDecrypt("vinculo_ativo");

    setVinculoEscolhido({
      id: vinculoAtivo.id,
      perfil: vinculoAtivo.perfil.nome,
      estabelecimentoDeSaude: vinculoAtivo.estabelecimento.nome,
      favorito: vinculoAtivo.favorito,
    });

    const handleVinculos = async () => {
      const response = await await api.post("/buscarVinculo", {
        id_usuario: usuario.co_id,
        ativos: true,
      });

      const vinculos = response.data.vinculosTratados;

      setVinculos(vinculos);
      setVinculosList(vinculos);

      getOpcoesPerfil(vinculos);
    };

    const getOpcoesPerfil = (vinculos) => {
      const nomePerfis = vinculos.map((vinculo) => vinculo.perfil);
      const nomePerfisFiltrado = nomePerfis.filter(
        (nomeVinculo, idx) => nomePerfis.indexOf(nomeVinculo) === idx
      );
      setPerfilList(nomePerfisFiltrado);
    };

    handleVinculos();
  }, []);

  const handlePerfil = (selecionado) => {
    setPerfil(selecionado);
    setIdVinculoSelecionado("");

    if (vinculosList) {
      if (selecionado === "") {
        setVinculos(vinculosList);
      } else {
        const vinculosPorPerfil = vinculosList.filter(
          (vinculo) => vinculo.perfil === selecionado
        );
        setVinculos(vinculosPorPerfil);
      }
    }
  };

  const handleVinculoEscolhido = async () => {
    try {
      if (idVinculoSelecionado === "") {
        return;
      }

      const { data } = await api.post(`/vinculo/${idVinculoSelecionado}`);

      // localStorage.setItem("vinculo_ativo", JSON.stringify(data));
      setItemEncryp("vinculo_ativo", data);

      setVinculoEscolhido({
        id: vinculo.id,
        perfil: vinculo.perfil,
        estabelecimentoDeSaude: vinculo.estabelecimentoDeSaude,
        favorito: vinculo.favorito,
      });

      handleAtualizacao();
    } catch (error) {
      console.error("Ocorreu um erro:", error.message);
    }
    setOpenVinculo(false);
  };

  return (
    <Box sx={{ minHeight: "48px" }}>
      <AppBar
        sx={{
          background: "#FFFFFF",
          color: "black",
          boxShadow: "0px 1px 8px 0px rgba(0, 0, 0, 0.15)",
          position: "static",
          minHeight: "48px",
          padding: "6px 0px",
          boxSizing: "border-box !important",
          paddingRight: "30px",
        }}
      >
        <Toolbar
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "10px",
            minHeight: "48px",
          }}
          variant="dense"
        >
          <Stack direction="row" gap="40px">
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
              }}
            >
              <Box sx={{ width: "24px", height: "24px" }}>
                <IconUser sx={{ width: "24px", height: "24px" }} />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  flexWrap: "wrap",
                  gap: "4px",
                }}
              >
                <Typography sx={{ display: { xs: "none", sm: "flex" } }}>
                  Perfil:
                </Typography>
                <Typography>{vinculoEscolhido.perfil}</Typography>
              </Box>
            </Box>

            <Box
              sx={{
                display: { xs: "none", md: "flex" },
                alignItems: "center",
                justifyContent: "center",
                gap: "4px",
              }}
            >
              <Box sx={{ width: "24px", height: "24px" }}>
                <IconLocation width="24px" height="24px" />
              </Box>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  flexWrap: "wrap",
                  gap: "4px",
                }}
              >
                <Typography sx={{ display: { xs: "none", md: "flex" } }}>
                  Estabelecimento de saúde:
                </Typography>
                <Typography>
                  {vinculoEscolhido.estabelecimentoDeSaude}
                </Typography>
              </Box>
            </Box>
          </Stack>
          <Button
            color="primary"
            variant="outlined"
            onClick={() => setOpenVinculo(true)}
            sx={{
              width: { xs: "100px", sm: "180px" },
              minWidth: { xs: "100px", sm: "180px" },
              height: "30px",
              fontSize: "16px",
              fontWeight: "500",
              textTransform: "math-auto",
              gap: "4px",
              whiteSpace: "nowrap",
            }}
          >
            <Box width="24px" height="24px">
              <IconChange width="24px" height="24px" />
            </Box>
            <Box component="span" sx={{ display: { xs: "none", sm: "flex" } }}>
              Alternar
            </Box>
            vínculo
          </Button>
        </Toolbar>
      </AppBar>

      <ModalDialogs
        maxWidth="700px !important"
        open={openVinculo}
        onClose={() => setOpenVinculo(false)}
        title="Alternar vínculo"
        primaryButtonText="Salvar"
        onActionPrimary={handleVinculoEscolhido}
        body={
          <Stack
            sx={{
              width: {
                xs: "100%",
                sm: "500px !important",
                md: "660px !important",
              },
            }}
          >
            <Stack
              sx={{
                width: "100%",
                boxSizing: "border-box !important",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                flexDirection: "row",
                flexWrap: "wrap",
                mb: 2,
              }}
            >
              <Typography
                fontSize={"20px !important"}
                sx={{ color: "black", marginRight: "10px" }}
              >
                Selecionar vínculo
              </Typography>
              <Select
                required
                style={{
                  border: "1px solid #1E729F",
                  borderRadius: 5,
                  textAlign: "left",
                  boxSizing: "border-box",
                }}
                sx={{
                  width: { xs: "100%", sm: "200px", md: "300px" },
                }}
                value={perfil}
                displayEmpty
                onChange={(e) => handlePerfil(e.target.value)}
              >
                <MenuItem value="">Todos</MenuItem>
                {perfilList.map((nome, index) => {
                  return (
                    <MenuItem value={nome} key={index}>
                      {nome}
                    </MenuItem>
                  );
                })}
              </Select>
            </Stack>
            {vinculos.map((vinc, index) => {
              const active = idVinculoSelecionado === vinc.id;
              return (
                <Button
                  key={index}
                  sx={{
                    boxSizing: "border-box !important",
                    width: "100%",
                    textAlign: "left",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    border: "1px solid grey",
                    p: 2,
                    mb: 1,
                    backgroundColor: active ? "#1E729F" : "white",
                    color: active ? "white" : "#3E94C2",
                    pointerEvents: active ? "none" : "auto",
                  }}
                  onClick={() => {
                    setIdVinculoSelecionado(vinc.id);
                  }}
                >
                  <Stack>
                    <Typography sx={{ fontWeight: "bold" }}>
                      {vinc.perfil}
                    </Typography>
                    <Typography>{vinc.estabelecimentoDeSaude}</Typography>
                  </Stack>
                  <Button>
                    {vinc.favorito ? (
                      <IconStarFill />
                    ) : (
                      <>
                        <IconStar />
                      </>
                    )}
                  </Button>
                </Button>
              );
            })}
          </Stack>
        }
      />
    </Box>
  );
}
